var React = require('react');

function Zero (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 5.23723L18.9365 3.22511L17.1269 4.98961C15.7932 3.68918 14.0156 3 12 3C7.58878 3 4.34964 6.25714 4.34964 12.0009C4.34964 13.7792 4.6604 15.3203 5.22157 16.5983L3 18.7645L5.06354 20.7766L6.86956 19.0156C8.19967 20.3126 9.97552 21 12 21C16.3863 21 19.6503 17.7429 19.6503 11.9991C19.6503 10.2225 19.3378 8.68312 18.7749 7.4052L21 5.23723ZM8.50689 12.0009C8.50689 8.04762 9.93468 6.40606 12 6.40606C12.982 6.40606 13.8202 6.78701 14.4276 7.62165L8.56906 13.3342C8.52821 12.9238 8.50689 12.4788 8.50689 12.0009ZM15.4682 12.0009C15.4682 15.9541 14.0404 17.5957 12 17.5957C11.0108 17.5957 10.1691 17.2182 9.55997 16.3922L15.4079 10.69C15.4469 11.0952 15.4682 11.5316 15.4682 12.0009Z","fill":"white"}));
}

Zero.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Zero;

Zero.default = Zero;
